import React from "react";
import { useState } from "react";
// import { AuthContext } from "../context/AuthProvider";
import { FaUserCircle } from "react-icons/fa";
import { BiLogOut } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import "../css/headerBar.sass";
import { post } from "../utils/api";
import apiServer from "../constants/apiServer";
import { Navigate, useNavigate } from "react-router-dom";
import AdaAlert from "./AdaAlert";
import PopupLoading from "./PopupLoading";
import logo from "../image/ada-logo.svg";


const HeaderBar = () => {

  const navigate = useNavigate();

  // const { auth } = useContext(AuthContext);
  const [openProfile, setOpenProfile] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const adminInfo = JSON.parse(localStorage.getItem('admin'));

  const handleLogout = async() => {
    setLoading(true);
    try {
      // withCredentials: true sends the httpOnly token cookie to the backend,
      // which clears it on its side. The browser also removes the cookie from
      // the Set-Cookie response, so we only need to clear our non-sensitive UI state.
      const { data, status } = await post(apiServer.auth.logout);
      
      localStorage.removeItem('token');
      localStorage.removeItem('admin');
      localStorage.removeItem('userId');

      if(status >= 400){
        console.log(data.message);
        setError(data.message)
      }else{
        if (status === 200) {
          setSuccess(data.message);
        }
      }
      
    } catch (err) {
      console.log("error ", err.message);
      // Even on error, clear local state so the UI is not stuck.
      localStorage.removeItem('token');
      localStorage.removeItem('admin');
      localStorage.removeItem('userId');
      setError(err.message);
    } finally {
      setTimeout(()=> {
        setLoading(false);
      },1000)
    }
  };

  const handleRouteDashboard = () => {
    navigate('/dashboard', { replace: true })
  }

  // console.log("error:::",error)

  // if(loading) return <PopupLoading text={"Logging out..."} />

  return (
    <>
      {success && <Navigate to="/login" replace="true" />}
      <div className="ada-admin-header-bar">
        <div className="ada-admin-logo" onClick={handleRouteDashboard}>
          <img src={logo} alt='ada-logo' />
        </div>
        <div className="ada-admin-header-admin-profile">
          <div
            className="ada-admin-header-admin-profile-name"
            onClick={() => {
              setOpenProfile(!openProfile);
            }}
          >
            <FaUserCircle size="20px" />
            &nbsp;{adminInfo?.name}
          </div>
          {openProfile && (
            <div className="ada-admin-header-profile-dropdown">
              <button>
                <CgProfile size="20px" />
                &nbsp;Profile
              </button>
              <button onClick={handleLogout}>
                <BiLogOut size="20px" />
                &nbsp;Logout
              </button>
            </div>
          )}
        </div>
      </div>
      {error && <AdaAlert type={'error'} message={error} />}
      {loading && <PopupLoading text={"Logging out..."} />}
    </>
  );
};

export default HeaderBar;
